import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'
import { Skeleton } from '@/common/ui/skeleton'
import {
	Bar,
	BarChart,
	CartesianGrid,
	Legend,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from 'recharts'

interface BrokeFlexOpensByDayWindowChartProps {
	opensByDayWindow?: Record<string, number>
	isLoading?: boolean
	title?: string
}

export default function BrokeFlexOpensByDayWindowChart({
	opensByDayWindow,
	isLoading,
	title = 'การเปิดดูตามช่วงเวลา',
}: BrokeFlexOpensByDayWindowChartProps) {
	if (isLoading) {
		return (
			<Card>
				<CardHeader>
					<CardTitle>{title}</CardTitle>
				</CardHeader>
				<CardContent>
					<Skeleton className="h-[300px] w-full" />
				</CardContent>
			</Card>
		)
	}

	if (!opensByDayWindow || Object.keys(opensByDayWindow).length === 0) {
		return (
			<Card>
				<CardHeader>
					<CardTitle>{title}</CardTitle>
				</CardHeader>
				<CardContent>
					<div className="flex h-[300px] items-center justify-center rounded-lg border border-dashed">
						<p className="text-muted-foreground">ไม่มีข้อมูล</p>
					</div>
				</CardContent>
			</Card>
		)
	}

	// Transform data for chart
	const chartData = Object.entries(opensByDayWindow).map(([window, count]) => ({
		window,
		opens: count,
	}))

	// Sort by day window order
	const dayOrder = ['day0', 'day1', 'day2', 'day3-7', 'day8-14', 'day15-30']
	chartData.sort(
		(a, b) => dayOrder.indexOf(a.window) - dayOrder.indexOf(b.window),
	)

	const formatWindowLabel = (window: string) => {
		const labels: Record<string, string> = {
			day0: 'วันแรก',
			day1: 'วันที่ 2',
			day2: 'วันที่ 3',
			'day3-7': 'วันที่ 4-7',
			'day8-14': 'วันที่ 8-14',
			'day15-30': 'วันที่ 15-30',
		}
		return labels[window] || window
	}

	return (
		<Card>
			<CardHeader>
				<CardTitle>{title}</CardTitle>
				<p className="text-sm text-muted-foreground">
					จำนวนการเปิดดูข้อความในแต่ละช่วงเวลาหลังจากส่ง
				</p>
			</CardHeader>
			<CardContent>
				<ResponsiveContainer width="100%" height={300}>
					<BarChart data={chartData}>
						<CartesianGrid strokeDasharray="3 3" />
						<XAxis
							dataKey="window"
							tickFormatter={formatWindowLabel}
							angle={-45}
							textAnchor="end"
							height={80}
						/>
						<YAxis />
						<Tooltip
							labelFormatter={formatWindowLabel}
							formatter={(value: number) => [
								`${new Intl.NumberFormat('th-TH').format(value)} ครั้ง`,
								'การเปิดดู',
							]}
						/>
						<Legend />
						<Bar dataKey="opens" fill="#3b82f6" name="การเปิดดู" />
					</BarChart>
				</ResponsiveContainer>
			</CardContent>
		</Card>
	)
}
